export default {
  notFound: {
    tabTitle: "NotFound",
    text: {
      title: "404",
      describe: "Sorry, the page you're looking for cannot be found",
    },
  },
};
